import React from 'react';
import ProductItemView from '../ProductItemViewMobile';
import logging from '../../resource/middleware_mobile/logging.png';

const LoggingMobile = () => {
    return (
        <ProductItemView
            title="Logging avanzado"
            items={["Garantía de trazabilidad completa", "Niveles de trazabilidad: alertas, debug, etc "]}
            image={logging}
            centered
            withGap />
    );
};

export default LoggingMobile;